<script>
  import ProductCardsList from './ProductCardsList.svelte';
  import trackClose from '../events/trackClose';

  /**
 *
 *
 *
 *
 *
 *
 */
  /*                */
  let {
    sourceVariationId,
    recommendations,
    widgetTracking,
    widgetAdditionalClickTracking,
    featuresState = {}
  } = $props();

  let hasSheetBeenOpened = $state(false);

  const pageName = 'DetailViewSheet';

  document.addEventListener('oc-sheet-open', (event) => {
    if (event.detail.id === `reco_aos_sheet_${sourceVariationId}`) {
      hasSheetBeenOpened = true;
    }
  });

  document.addEventListener('oc-sheet-after-close', (event) => {
    if (event.detail.id === `reco_aos_sheet_${sourceVariationId}` && hasSheetBeenOpened) {
      trackClose(widgetTracking, '99');
      hasSheetBeenOpened = false;
    }
  });
</script>

<div class="reco_aos_sheet_wrapper">
  <oc-sheet-v1 id="reco_aos_sheet_{sourceVariationId}" headline={'Passend dazu'}>
    {#if hasSheetBeenOpened}
      <ProductCardsList
        {recommendations}
        featureIndex="{'99'},"
        {widgetTracking}
        {widgetAdditionalClickTracking}
        {pageName}
        trackOpenAndScroll={true}
        {featuresState} />
    {/if}
  </oc-sheet-v1>
  <div data-oc-sheet-v1-open data-oc-sheet-v1-open.id="reco_aos_sheet_{sourceVariationId}">
    <oc-link-v2 class="reco_aos_sheet_button" as-button>Mehr anzeigen</oc-link-v2>
  </div>
</div>

<style lang="scss">
  .reco_aos_sheet_button {
    display: inline-block;
    margin-top: 24px;
  }
</style>
